import {
  motion,
  MotionValue,
  useSpring,
  useTransform,
  useViewportScroll,
} from "framer-motion";
import { useCallback, useRef, useState } from "react";
import { useEffectOnce, useWindowSize } from "react-use";
import styled from "styled-components";
import { useResizeObserver } from "../../lib/hooks/useResizeObserver";
import { TimelineZoomData } from "../../mock/timeline";
import { Box } from "../Box";

interface TimelineScrollZoomProps {
  scale: Array<string>;
  rotation: Array<string>;
  x: Array<string>;
  yFactor: number;
}

const Static = styled(Box)`
  position: relative;
`;
const XDate = styled(motion.div)`
  transform-origin: top;
`;

const dist = 0.5;

export const TimelineScrollZoom: React.FC<TimelineScrollZoomProps> = ({
  yFactor,
  x,
  rotation,
  scale,
  children,
}) => {
  const [y, setY] = useState(0);
  const elRef = useRef<HTMLElement>(null);

  const { width, height } = useWindowSize();
  const { scrollY } = useViewportScroll();

  const dateMotion = useTransform(scrollY, (scrollY) => {
    const top = scrollY + 40;
    if (top < y) {
      return 0;
    }
    if (top > y + yFactor * width) {
      return 1;
    }

    return (top - y) / (yFactor * width);
  });

  const yyMotion = useTransform(scrollY, (scrollY) => {
    const top = scrollY + 40;

    if (top < y) {
      return -(yFactor * width);
    }
    if (top > y + yFactor * width) {
      return 1;
    }

    return top - y - yFactor * width;
  });

  const physics = { damping: 15, mass: 0.27, stiffness: 55 }; // easing of smooth scroll
  const spring = useSpring(dateMotion, physics); // apply easing to the negative scroll value
  const yyMotionS = useSpring(yyMotion, physics); // apply easing to the negative scroll value

  // const dateMotion2 = useTransform(dateMotion, [1, height], [1, zoomFactor]);
  // const dateMotionX = useTransform(dateMotion, [1, height], [0, xShift]);
  const dateMotion3 = useTransform(spring, (m) => m * 1);
  // const spring2 = useSpring(dateMotion3, physics); // apply easing to the negative scroll value
  // const springX = useSpring(dateMotionX, physics); // apply easing to the negative scroll value

  const scaleMotion = useTransform(spring, [0, 1], scale);
  const yMotion = useTransform(spring, [0, 1], ["-100vw", "0vh"]);
  const xMotion = useTransform(spring, [0, 1], x);
  const rMotion = useTransform(spring, [0, 1], rotation);

  useEffectOnce(() => {
    const timeout = setTimeout(() => {
      if (elRef.current) {
        console.log("run");
        setY(elRef.current.getBoundingClientRect().top + scrollY.get());
      }
    }, 500);
    return clearTimeout(timeout);
  });

  const resizePageHeight = useCallback(() => {
    elRef.current &&
      setY(elRef.current.getBoundingClientRect().top + scrollY.get());
  }, [scrollY]);

  useResizeObserver(elRef, resizePageHeight);

  return (
    <Box pt={yFactor * width} ref={elRef as any}>
      <Static ref={elRef as any} id="test">
        <XDate
          style={{
            y: yyMotionS,
            x: xMotion,
            scale: scaleMotion,
            rotate: rMotion,
          }}
        >
          {children}
        </XDate>
      </Static>
    </Box>
  );
};
